const Uppy = require('@uppy/core')
const FileInput = require('@uppy/file-input')
const XHRUpload = require('@uppy/xhr-upload')
const ProgressBar = require('@uppy/progress-bar')
const AwsS3 = require('@uppy/aws-s3')

export function fileUpload(container){
  var form = container.closest('form')
  var submit_button = form.querySelector('input[type=submit]')
  var preview = container.querySelector('.directupload-preview')
  var fileInput = container.querySelector('.directupload-file')
  var hiddenField = container.querySelector('.directupload-result')

  var uploadServer = fileInput.dataset.uploadServer

  var endpoint = "/upload"
  if(fileInput.dataset.endpoint){ endpoint = "/" + fileInput.dataset.endpoint + "/upload" }

  var button_text = fileInput.dataset.buttonText || "Choose files"
  var uploading_text = fileInput.dataset.uploadingText || "Uploading …"

  var restrictions = {}
  if (fileInput.accept !== ''){ restrictions['allowedFileTypes'] = fileInput.accept.split(',') }


  fileInput.style.display = 'none'

  var uppy = new Uppy({ 
    id: fileInput.id,
    debug: true,
    autoProceed: true,
    // restrictions: { allowedFileTypes: fileInput.accept.split(','), }
    restrictions: restrictions,
  })

  uppy.use(FileInput, {
    target: container,
    locale: { strings: { chooseFiles: button_text } },
  })

  uppy.use(ProgressBar, {
    target: preview,
    hideAfterFinish: true,
  })

  var progressBar = container.querySelector('.uppy-ProgressBar')
  progressBar.style.display = 'none'

  uppy.on('file-added', (file) => {
    progressBar.style.display = 'block'
    submit_button.disabled = true
    preview.innerHTML = uploading_text
  })

  if (uploadServer == 's3') {
    uppy.use(AwsS3, {
      getUploadParameters: function (file) {
        return fetch('/presign?filename=' + file.name, { // Shrine's presign endpoint
          credentials: 'same-origin', // send cookies
        })
          .then(function (response) { return response.json() })
      }
    })
  } else {
    uppy.use(XHRUpload, {
      endpoint: endpoint, // Shrine's upload endpoint
      fieldName: 'file',
    })
  }


  uppy.on('upload-success', function (file, data) {
    preview.innerHTML = file.name
    progressBar.style.display = 'none'
    submit_button.disabled = false

    if (uploadServer == 's3') {
      var key = file.meta['key'].match(/cache\/([^\?]+)/)[1]

      // construct uploaded file data in the format that Shrine expects
      var uploadedFileData = JSON.stringify({
        id: key , // extract key without prefix
        storage: 'cache',
        metadata: {
          size:      file.size,
          filename:  file.name,
          mime_type: file.type,
        }
      })
    } else {
      var uploadedFileData = JSON.stringify(data)
    }

    hiddenField.value = uploadedFileData
  })

  return uppy
}


